<template>
  <div class="col-xl-6 col-lg-6">
    <div class="card employee-status">
      <div class="card-header pb-0">
        <h3>Employee status</h3>
      </div>
      <div class="card-body">
        <div class="table-responsive theme-scrollbar">
          <table class="table table-bordernone">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Designation</th>
                <th scope="col">Skill Level</th>
                <th scope="col">Experience</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in menu" :key="index">
              <tr>
                <td>
                  <div class="d-flex"><img :src="item.img" alt="">
                    <div class="flex-grow-1"><a> <router-link to="/users/profile">
                          <h5>{{ item.name }} <span class="text-muted">{{ item.pera }}</span></h5>
                        </router-link></a></div>
                  </div>
                </td>
                <td>{{ item.designation }}</td>
                <td>
                  <div class="progress-showcase">
                    <div class="progress" style="height: 8px;">
                      <div class="progress-bar" :class="item.skillClass" role="progressbar" :style="{ 'width': item.skill }"
                        aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </td>
                <td>{{ item.exp }}</td>
              </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import { EmployeeData } from '../../../data/widgets/general/data'
export default {
  name: 'employeePage',
  data() {
    return {
      menu: EmployeeData
    }
  }
}
</script>